import { DocumentMode } from '@root/@types/types';

import type { TransitionConfigMap } from '../types';

export const DRAFT_TRANSITIONS: TransitionConfigMap = {
  REVIEW: {
    [DocumentMode.SUBMISSIONS]: () => ({
      title: 'Ready to review the contract?',
      content:
        'By setting this contract to Review, it will become read-only and ready for review. If further edits are needed, it can be returned to Draft.',
      buttons: {
        cancel: true,
        confirm: { text: 'Yes, ready for review' },
      },
      icon: { type: 'valid' },
    }),
    [DocumentMode.TEMPLATES]: () => ({
      title: 'Submit template for review?',
      content:
        'By setting this template to Review, it will be ready for Super Admin sign-off before it can be published.',
      buttons: {
        cancel: true,
        confirm: { text: 'Yes, submit for review' },
      },
      icon: { type: 'valid' },
    }),
    [DocumentMode.ENDORSEMENTS]: () => ({
      title: 'Ready to review the endorsement?',
      content:
        'By setting this endorsement to Review, it will become read-only and ready for review. If further edits are needed, it can be returned to Draft.',
      buttons: {
        cancel: true,
        confirm: { text: 'Yes, ready for review' },
      },
      icon: { type: 'valid' },
    }),
  },
  // Legacy DRAFT → FINAL path used when the EndorsementReview flag is off; without it the
  // confirmation modal disappears and Final applies immediately.
  FINAL: {
    [DocumentMode.ENDORSEMENTS]: () => ({
      title: 'Ready to finalise endorsement?',
      content:
        'By setting this endorsement to Final, it will be locked. Any further changes must be made as a new endorsement.',
      buttons: {
        cancel: true,
        confirm: { text: 'Yes, finalise endorsement' },
      },
      icon: { type: 'valid' },
      validation: { required: true },
    }),
  },
  PUBLISHED: {
    [DocumentMode.TEMPLATES]: () => ({
      title: 'Ready to publish template?',
      content: 'By setting this template to Published, it will become available for users when creating new contracts.',
      buttons: {
        cancel: true,
        confirm: { text: 'Yes, publish template' },
      },
      icon: { type: 'valid' },
    }),
    [DocumentMode.BRANDING]: () => ({
      title: 'Ready to publish branding?',
      content: 'By setting this branding to published it will become available for users.',
      buttons: {
        cancel: true,
        confirm: { text: 'Yes, publish branding' },
      },
      icon: { type: 'valid' },
      validation: { required: true },
    }),
  },
  ARCHIVED: {
    [DocumentMode.SUBMISSIONS]: () => ({
      title: 'Archive contract?',
      content:
        'Setting this contract to Archived will take it out of active use. It must be returned to Draft to make it editable again.',
      buttons: {
        cancel: true,
        confirm: {
          text: 'Yes, archive contract',
        },
      },
      icon: { type: 'warning' },
    }),
    [DocumentMode.TEMPLATES]: () => ({
      title: 'Archive template?',
      content:
        'Setting this template to Archived will take it out of active use. It must be returned to Draft to make it editable again.',
      buttons: {
        cancel: true,
        confirm: { text: 'Yes, archive template' },
      },
      icon: { type: 'warning' },
    }),
    [DocumentMode.ENDORSEMENTS]: () => ({
      title: 'Archive endorsement?',
      content:
        'Setting this endorsement to Archived will take it out of active use. It must be returned to Draft to make it editable again.',
      buttons: {
        cancel: true,
        confirm: {
          text: 'Yes, archive endorsement',
        },
      },
      icon: { type: 'warning' },
    }),
  },
};
